import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';
import ConversationStore from './ConversationStore.js';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const ActionTypes = Constants.ActionTypes;
const CHANGE_EVENT = 'change'; // globālais
const CHANGE_MEMBER_EVENT = 'changeMember'; // tikai, tiem kuri saistīti ar lietotāju datiem, piem. memberImage, memberName

const _members = {};
let _searchedMemberIds = [];
let _fetchedMemberIdsPage = [];
let _searchedMembersPage = 0;
let _loading = false;
let _myID = null;
let _limitedMessages = false; // vai ir ierobežotas darbības ar vēstulēm
let _hasPaid = true; // vai maksātājs
let _overConversationLimit = false; // vai pāri sarakstu limitam
let _submitOnEnter = false; // submit vēstulei, ja nospiests enter
let _characterLimit = null;
EventEmitter.prototype._maxListeners = 0; // neierobežots eventu daudzums
let _fetchedMembersPage = 1;
let _fetchedMemberIds = [];

var MemberStore = assign({}, EventEmitter.prototype, {

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  emitChangeMember() {
    this.emit(CHANGE_MEMBER_EVENT);
  },

  /**
	* @param {function} callback
	*/
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
	* @param {function} callback
	*/
  addChangeMemberListener(callback) {
    this.on(CHANGE_MEMBER_EVENT, callback);
  },

  /**
	* @param {function} callback
	*/
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  /**
	* @param {function} callback
	*/
  removeChangeMemberListener(callback) {
    this.removeListener(CHANGE_MEMBER_EVENT, callback);
  },

  addMember(member) {
    if (!_members[member._id]) _members[member._id] = {};

    // default vērtības
    const memberDefault = {
      _id: null,
      age: null,
      blocked: false,
      favorite: false,
      can_access: false,
      image: null,
      name: '',
      sex: null,
      status: 'delete',
      answer_score: 0,
      has_paid: false,
      deleted: false,
      location: '',
      image_count: 0,
      about_me: '',
      was_messaged_by_me: false,
      was_visited_by_me: false,
      km_from_me: null,
      admin: [],
    };

    _members[member._id] = _.assign(memberDefault, member);

    // pievieno savu id
    if (member.my_id && !_myID) {
      _myID = member.my_id;
    }
  },

  addMembers(members, group, page) {
    members.forEach(function (member) {
      if (group == 'searched') {
        if (member.status == 'deleted') {
          return;
        }
        this.addSearchedMemberId(member._id);
        if (_.has(_members, member._id)) {
          return;
        }
      }
      if (group == 'fetched') {
        /*
				if (member.status == 'deleted') {
					return;
				}
				*/
        this.addFetchedMemberId(member._id);

        if (_.has(_members, member._id)) {
          return;
        }
      }
      this.addMember(member);
    }, this);

    if (this.getFetchedMemberPage(page) == false) {
      this.addFetchedMemberPage(members, page);
    }
  },

  addSearchedMemberId(memberId) {
    _searchedMemberIds.push(memberId);
  },

  addFetchedMemberId(memberId) {
    _fetchedMemberIds.push(memberId);
  },

  addFetchedMemberPage(members, page) {
    members.forEach(function (member) {
      if (!_fetchedMemberIdsPage[page]) _fetchedMemberIdsPage[page] = [];
      _fetchedMemberIdsPage[page].push(this.get(member._id));
    }, this);
  },

  getFetchedMemberPage(page) {
    if (!_fetchedMemberIdsPage[page]) {
      return false;
    }

    return _fetchedMemberIdsPage[page];
  },

  addFetchedMember(memberId) {
    _fetchedMemberIds.push(memberId);
  },

  setLimitedMessages(value) {
    _limitedMessages = value;
  },

  setHasPaid(value) {
    _hasPaid = value;
  },

  setOverConversationLimit(value) {
    _overConversationLimit = value;
  },

  /**
	* Mainīt can_access statusu
	* @param {string} memberId
	* @param {boolean} value
	*/
  setCanAccess(memberId, value) {
    if (!_members[memberId]) {
      return false;
    }

    _members[memberId].can_access = value;
  },

  /**
	* Mainīt blocked statusu
	* @param {string} memberId
	* @param {boolean} value
	*/
  setBlocked(memberId, value) {
    if (!_members[memberId]) {
      return false;
    }

    _members[memberId].blocked = value;
  },

  /**
	* Vai sūtīt vēstuli, ja nospiests enter
	* @param {boolean} value
	*/
  setSubmitOnEnter(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _submitOnEnter = value;
  },

  setCharacterLimit(value) {
    _characterLimit = value;
  },

  /**
	 * Vai pašlaik ielādē lietotājus
	 * @param {boolean} value
	 */
  setLoading(value) {
    if (!_.isBoolean(value)) {
      return false;
    }
    _loading = value;

    return _loading;
  },

  /**
	 * Uzstāda meklēto lietotāju lapu
	 */
  setSearchedMembersPage(value) {
    _searchedMembersPage = parseInt(value);
  },

  setFetchedMembersPage(value) {
    _fetchedMembersPage = parseInt(value);
  },

  /**
	* @param {string} id
	*/
  get(id) {
    return _members[id];
  },

  getAll() {
    return _members;
  },

  getAllFetched(members_ids) {
    const fetched = [];
    const all_fetchedMemberIds = MemberStore.getAllIds();

    if (typeof members_ids !== 'undefined' && Object.keys(members_ids).length > 0) {
      members_ids = JSON.parse(members_ids);

      members_ids.forEach(function (id) {
        const member = this.get(id);
        if (typeof member !== 'undefined') {
          fetched.push(member);
        }
      }, this);
    } else if (all_fetchedMemberIds != null) {
      all_fetchedMemberIds.forEach(function (id) {
        if (_myID !== id && Object.keys(members_ids).length > 0 && members_ids.indexOf(id) != -1) {
          fetched.push(this.get(id));
        } else if (_myID !== id) {
          fetched.push(this.get(id));
        }
      }, this);
    }

    return fetched;
  },

  getFetchedPage() {
    const fetched = [];
    _fetchedMemberIds = _.uniq(_fetchedMemberIds);
    _fetchedMemberIds.forEach(function (id) {
      if (_myID !== id) {
        fetched.push(this.get(id));
      }
    }, this);

    return fetched;
  },

  /*
	* Atgriež visu lietotāju id vērtības
	*/
  getAllIds() {
    if (_.isEmpty(_members)) {
      return null;
    }

    return _.map(_members, '_id');
  },

  getMyID() {
    return _myID;
  },

  getMyProfile() {
    return _members[_myID];
  },

  getCanAccess(memberId) {
    if (!_members[memberId]) {
      return false;
    }

    return _members[memberId].can_access;
  },

  getBlocked(memberId) {
    if (!_members[memberId]) {
      return null;
    }

    return _members[memberId].blocked;
  },

  getLimitedMessages() {
    return _limitedMessages;
  },

  getHasPaid() {
    return _hasPaid;
  },

  getOverConversationLimit() {
    return _overConversationLimit;
  },

  getSubmitOnEnter() {
    return _submitOnEnter;
  },

  getCharacterLimit() {
    return _characterLimit;
  },

  getLoading() {
    return _loading;
  },

  getAllSearched() {
    const searched = [];
    _searchedMemberIds = _.uniq(_searchedMemberIds);
    _searchedMemberIds.forEach(function (id) {
      if (_myID !== id) {
        searched.push(this.get(id));
      }
    }, this);

    return searched;
  },

  /**
	 * Iegūst meklēto lietotāju pēdējo ielādēto lapu
	 */
  getSearchedMembersPage() {
    return _searchedMembersPage;
  },

  getFetchedMembersPage() {
    return _fetchedMembersPage;
  },

  removeSearchedMemberIds() {
    _searchedMemberIds = [];
  },

  removeFetchedMemberIds() {
    _fetchedMemberIds = [];
  },

  removeFetchedMemberIdsPage() {
    _fetchedMemberIdsPage = [];
  },
});

MemberStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.MEMBERS_LOAD_SUCCESS:
      var count = action.members.length;
      var doEmitChange = false;

      if (count > 0) {
        var characterLimit = action.characterLimit;
        var limitMessages = action.limitedMessages;
        var hasPaid = action.hasPaid;
        var overConversationLimit = action.overConversationLimit;
        // lietotāji pirms pievienošanas
        const oldMembersData = _.clone(MemberStore.getAll());

        if (action.page) {
          MemberStore.setFetchedMembersPage(action.page);
        }

        MemberStore.addMembers(action.members);

        if (typeof characterLimit !== 'undefined') {
          MemberStore.setCharacterLimit(characterLimit);
        }

        if (typeof hasPaid !== 'undefined') {
          MemberStore.setHasPaid(hasPaid);
        }

        // ja mainās limitMessages vērtība, tad globālais change
        if (typeof limitMessages !== 'undefined' && limitMessages != MemberStore.getLimitedMessages()) {
          MemberStore.setLimitedMessages(limitMessages);
          doEmitChange = true;
        } else if (typeof overConversationLimit !== 'undefined' && overConversationLimit != MemberStore.getOverConversationLimit()) {
          MemberStore.setOverConversationLimit(overConversationLimit);
          doEmitChange = true;
        } else {
          // Ja pievienotie dati atšķiras
          if (_.isEmpty(oldMembersData) || !_.isEqual(MemberStore.getAll(), oldMembersData)) {
            MemberStore.emitChangeMember();
          }
        }
      }

      if (action.submitOnEnter != MemberStore.getSubmitOnEnter()) {
        MemberStore.setSubmitOnEnter(action.submitOnEnter);
        doEmitChange = true;
      }

      MemberStore.setLoading(false);

      if (doEmitChange) {
        MemberStore.emitChange();
      }
      break;

    case ActionTypes.MEMBERS_FETCH_SUCCESS:
      var count = action.members.length;
      var doEmitChange = false;

      if (count > 0) {
        var limitMessages = action.limitedMessages;
        var hasPaid = action.hasPaid;
        var overConversationLimit = action.overConversationLimit;

        if (action.page) {
          MemberStore.setFetchedMembersPage(action.page);
          doEmitChange = true;
        }

        MemberStore.removeFetchedMemberIds();
        MemberStore.addMembers(action.members, 'fetched', action.page);
      }

      MemberStore.setLoading(false);

      if (doEmitChange) {
        MemberStore.emitChange();
      }
      break;

    case ActionTypes.MESSAGES_LOAD_SUCCESS:
      // AppDispatcher.waitFor([MessageStore.dispatchToken]);
      var limitMessages = action.limitedMessages;
      var overConversationLimit = action.overConversationLimit;

      if (typeof limitMessages !== 'undefined' && limitMessages != MemberStore.getLimitedMessages()) {
        MemberStore.setLimitedMessages(limitMessages);
        MemberStore.emitChange();
      } else if (typeof overConversationLimit !== 'undefined' && overConversationLimit != MemberStore.getOverConversationLimit()) {
        MemberStore.setOverConversationLimit(overConversationLimit);
        doEmitChange = true;
      }
      break;

    case ActionTypes.MEMBER_BLOCK:
      MemberStore.setBlocked(action.memberId, true);
      if (typeof action.canAccess === 'boolean') {
        MemberStore.setCanAccess(action.memberId, action.canAccess);
      }
      MemberStore.emitChange();

      break;

    case ActionTypes.MEMBER_UNBLOCK:
      MemberStore.setBlocked(action.memberId, false);
      if (typeof action.canAccess === 'boolean') {
        MemberStore.setCanAccess(action.memberId, action.canAccess);
      }
      MemberStore.emitChange();

      break;

    case ActionTypes.CONVERSATIONS_LOAD_SUCCESS:
      // AppDispatcher.waitFor([ConversationStore.dispatchToken]);
      var limitMessages = action.limitedMessages;
      var overConversationLimit = action.overConversationLimit;

      if (typeof limitMessages !== 'undefined' && limitMessages != MemberStore.getLimitedMessages()) {
        MemberStore.setLimitedMessages(limitMessages);
        MemberStore.emitChange();
      } else if (typeof overConversationLimit !== 'undefined' && overConversationLimit != MemberStore.getOverConversationLimit()) {
        MemberStore.setOverConversationLimit(overConversationLimit);
        doEmitChange = true;
      }
      break;

    case ActionTypes.SUBMIT_ON_ENTER:
      if (action.value != MemberStore.getSubmitOnEnter()) {
        MemberStore.setSubmitOnEnter(action.value);
        MemberStore.emitChange();
      }

      break;
    case ActionTypes.SEARCHED_MEMBERS_LOAD:
      MemberStore.setLoading(true);
      MemberStore.emitChange();
      break;
    case ActionTypes.SEARCHED_MEMBERS_LOAD_SUCCESS:
      if (action.members.length > 0) {
        MemberStore.addMembers(action.members, 'searched');
      }
      if (action.page) {
        MemberStore.setSearchedMembersPage(action.page);
      }
      MemberStore.setLoading(false);
      MemberStore.emitChange();

      break;
    case ActionTypes.SEARCHED_MEMBERS_LOAD_FAIL:
      MemberStore.setLoading(false);
      MemberStore.emitChange();
      break;
    case ActionTypes.MEMBERS_FETCH_LOADED_PAGE:
      var members = MemberStore.getFetchedMemberPage(action.page);
      var count = members.length;
      var doEmitChange = false;

      if (count > 0) {
        MemberStore.setFetchedMembersPage(action.page);
        doEmitChange = true;

        MemberStore.removeFetchedMemberIds();
        MemberStore.addMembers(members, 'fetched', action.page);
      }

      MemberStore.setLoading(false);
      if (doEmitChange) {
        MemberStore.emitChange();
      }
      break;

    case ActionTypes.MEMBERS_FETCH_NEXT_PAGE_SUCCESS:
      var count = action.members.length;

      if (count > 0) {
        MemberStore.addMembers(action.members, 'fetched', action.page);
      }
      break;
    default:
			// do nothing
  }
});

module.exports = MemberStore;
